export default {
  listWrapper: 'flex w-full gap-[8px]',
  improvement: 'cursor-pointer rounded-lg border border-[#CEDCEC] w-full flex justify-center p-4 relative',
  activeImprovement: 'border-[#EC6D25] bg-[#F0F3F6]',
  checkIcon: 'absolute top-2 left-2',
};
